import styled from "styled-components";

export const DivSelectField = styled.div`
  margin-left: 0.5rem;
`;
